import styled from 'styled-components';
export var Dots = styled.div.withConfig({
  displayName: "Dots",
  componentId: "sc-11wwccr-0"
})(["margin-top:14px;text-align:center;"]);